import type * as ents from '@attain-apps/entities'

import type * as variableOverrides from '../../../variable-overrides'

export function getDraftVariableHolder({
  appId,
  scenarioId,
}: {
  readonly appId: ents.core.admin.App.Id
  readonly scenarioId: ents.core.admin.Scenario.Id
}): variableOverrides.models.Values.Holder {
  return {
    scenario: {
      appId,
      scenarioId,
    },
  }
}
